import { useNavigate } from 'react-router-dom';
import { roleCondition } from '../../../../libs/HelperContent';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

const useNavigateProfile = (feed) =>
{
	const userData = useSelector((state: any) => state?.mysession?.session);
	const navigate = useNavigate();

	const canNavigate = useMemo(() => feed?.userData?.role === 'company',
		[ feed?.userData?.role ]);

	const redirectToProfile = () =>
	{
		if (canNavigate)
		{
			if (feed?.companyId === userData?.companyId)
			{
				roleCondition(userData?.empRole)
					? navigate('/businessSettings/businessProfile')
					: navigate('/businessProfile');
			}
			else navigate(`/connections/companyProfile/${window.btoa(feed?.createdBy)}/feeds`);
		}
	};

	return { redirectToProfile, canNavigate };
};

export default useNavigateProfile;